import { gql } from "@/services/httpAdapter";

export const onUpdateSalesLeads = gql`
	subscription onUpdateSalesLeads($commissionCycleId: String!, $payPeriodId: String!) {
		onUpdateSalesLeads(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			salesLeads {
				_id
			}
		}
	}
`;

export const onUpdateDispositions = gql`
	subscription onUpdateDispositions($commissionCycleId: String!, $payPeriodId: String!) {
		onUpdateDispositions(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
			locationId
			commissionCycleId
			payPeriodId
			dispositions {
				_id
			}
		}
	}
`;

export const onUpdateCustomers = gql`
	subscription onUpdateCustomers($locationId: String) {
		onUpdateCustomers(locationId: $locationId) {
			locationId
			customers {
				_id
			}
		}
	}
`;
